import { CHANNEL_KEY_TO_CHANNEL_INFO } from "./config";
import { ALL_CHANNEL_KEYS, ChannelKey } from "./types";

/**
 * Given a URL, extracts it and returns protocol, host, pathname, search, hash
 * The return fields conform to https://developer.mozilla.org/en-US/docs/Web/API/URL
 *
 * For user input, we can use this function because it supports non-absolute
 * urls like `fb.com/john.doe`.
 *
 * If a url is not valid, all the fields are empty strings.
 *
 * Note that this function assumes that the input url does not have username,
 * password, port. For urls with these special properties, all the returned
 * fields will be empty.
 */
export function extractUrl(url: string) {
  const matched =
    /^([A-Za-z][0-9A-Za-z+.-]*:)?\/*([0-9A-Za-z.]+)(\/[^?#]*)?(\?[^#]*)?(#.*)?$/.exec(
      url
    );
  return {
    protocol: matched?.[1] || "",
    host: matched?.[2] || "",
    pathname: matched?.[3] || "",
    search: matched?.[4] || "",
    hash: matched?.[5] || "",
  };
}

export function getChannelKey(url: string): ChannelKey | undefined {
  const { protocol, host } = extractUrl(url);
  if (protocol !== "https:") return undefined;

  for (const key of ALL_CHANNEL_KEYS) {
    for (const domain of CHANNEL_KEY_TO_CHANNEL_INFO[key].acceptedDomains) {
      if (host === domain || host.endsWith("." + domain)) {
        return key;
      }
    }
  }
  return undefined;
}
